import React, { useState } from 'react'
import Modal from '../modal/modal'
import Button from '@mui/material/Button'
import { DialogActions } from '@mui/material';

export default function BulkAllocationModal(props) {
  const {
    selectedCount,
    onApprove,
    onDelete,
    onReject,
    onRecalculate,
    onCancel,
    open,
    dialogClose,
    processing = false
  } = props;

  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [actionType, setActionType] = useState(null);

  const handleActionClick = (type) => {
    // For approve and reject, go directly to comment modal (no confirmation needed)
    // For delete, show confirmation modal (no comment needed)
    if (processing) return;
    if (type === 'approve' || type === 'reject') {
      if (type === 'approve') {
        onApprove();
      } else if (type === 'reject') {
        onReject();
      }
    } else if (type === 'delete' || type === 'recalculate') {
      setActionType(type);
      setShowConfirmModal(true);
    }
  };

  const handleConfirm = async () => {
    if (processing) return;
    if (actionType === 'delete') {
      setShowConfirmModal(false);
      onDelete();
    } else if (actionType === 'recalculate') {
      await onRecalculate();
      setShowConfirmModal(false);
    }
  };

  return (
    <>
      <Modal
        open={open}
        onClose={dialogClose}
        fullWidth={true}
        maxWidth='md'
        modalHeading="Bulk Actions"
        showActionBtn
      >
        <p>{selectedCount} Timesheet records selected</p>

        <DialogActions className='actionbtn'>
          <div className='actionbtn'>
            <Button variant='contained' className="cancel-btn" onClick={() => handleActionClick('approve')} color='primary'>
              Accept/Approve
            </Button>
            <Button variant='contained' className="cancel-btn" onClick={() => handleActionClick('delete')} color='error'>
              Delete
            </Button>
            <Button variant='contained' className="cancel-btn" onClick={() => handleActionClick('reject')} color='warning' disabled={processing}>
              Reject
            </Button>
            <Button variant='contained' className="cancel-btn" onClick={() => handleActionClick('recalculate')} color='primary' disabled={processing || !onRecalculate}>
              Recalculate
            </Button>
            <Button variant='contained' className="cancel-btn" onClick={onCancel} color='' disabled={processing}>
              Cancel
            </Button>
          </div>
        </DialogActions>
      </Modal>
      <Modal
        open={showConfirmModal}
        onClose={() => setShowConfirmModal(false)}
        fullWidth={true}
        maxWidth='sm'
        modalHeading={`Confirm ${actionType} Action`}
        modalSaveTxt='Yes'
        modalCloseTxt='No'
        onClick={handleConfirm}
        showActionBtn
        savebtnClass='createBtn'
        cxlbtnClass='cancelBtn'
        primary
      >
        <p>{actionType === 'recalculate'
          ? 'Recalculate the selected pending timesheets using each user’s current Work Hour Settings? Their status will remain Pending.'
          : `Are you sure you want to perform this ${actionType} action?`}</p>
      </Modal>
    </>
  );
}
